(function (global, factory) {
    typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports, require('rxjs'), require('@angular/core'), require('@angular/common'), require('@angular/cdk/a11y'), require('@angular/cdk/portal'), require('@angular/cdk/coercion'), require('@shraddhar/web/button'), require('@shraddhar/web/ripple'), require('@angular/cdk/platform'), require('rxjs/operators'), require('@shraddhar/web/base'), require('@shraddhar/web/dom'), require('@material/dialog'), require('@shraddhar/web/overlay')) :
    typeof define === 'function' && define.amd ? define('@shraddhar/web/dialog', ['exports', 'rxjs', '@angular/core', '@angular/common', '@angular/cdk/a11y', '@angular/cdk/portal', '@angular/cdk/coercion', '@shraddhar/web/button', '@shraddhar/web/ripple', '@angular/cdk/platform', 'rxjs/operators', '@shraddhar/web/base', '@shraddhar/web/dom', '@material/dialog', '@shraddhar/web/overlay'], factory) :
    (global = global || self, factory((global.shraddhar = global.shraddhar || {}, global.shraddhar.web = global.shraddhar.web || {}, global.shraddhar.web.dialog = {}), global.rxjs, global.ng.core, global.ng.common, global.ng.cdk.a11y, global.ng.cdk.portal, global.ng.cdk.coercion, global.ng.web.button, global.ng.web.ripple, global.ng.cdk.platform, global.rxjs.operators, global.ng.web.base, global.ng.web.dom, global.mdc.dialog, global.ng.web.overlay));
}(this, (function (exports, rxjs, core, common, a11y, portal, coercion, button, ripple, platform, operators, base, dom, dialog, overlay) { 'use strict';

    var MdcDialogConfig = /** @class */ (function () {
        function MdcDialogConfig() {
            /** ID of the element that describes the dialog.  */
            this.ariaDescribedBy = null;
            /** Aria label to assign to the dialog element */
            this.ariaLabel = null;
            /** Whether the user can use escape key to close the dialog */
            this.escapeToClose = true;
            /** Whether the user can click outside to close the dialog */
            this.clickOutsideToClose = true;
            /** Applied automatically when the dialog has overflowing content to warrant scrolling. */
            this.scrollable = true;
            /** Applied automatically when the dialog's action buttons can't fit on a single line and must be stacked. */
            this.buttonsStacked = true;
            /** Whether the dialog should focus the first focusable element on open. */
            this.autoFocus = true;
            /**
            * Whether the dialog should restore focus to the
            * previously-focused element, after it's closed.
            */
            this.restoreFocus = true;
            /** Data to be injected into the dialog content. */
            this.data = null;
        }
        return MdcDialogConfig;
    }());

    /** Unique id for the created dialog. */
    var uniqueId = 0;
    /**  Reference to a dialog dispatched from the MdcDialog service. */
    var MdcDialogRef = /** @class */ (function () {
        function MdcDialogRef(_overlayRef, _portalInstance, id) {
            var _this = this;
            if (id === void 0) { id = "mdc-dialog-" + uniqueId++; }
            this._overlayRef = _overlayRef;
            this._portalInstance = _portalInstance;
            this.id = id;
            /** Subject for notifying the user that the dialog has finished opening. */
            this._afterOpened = new rxjs.Subject();
            /** Subject for notifying the user that the dialog has started closing. */
            this._beforeClosed = new rxjs.Subject();
            /** Subject for notifying the user that the dialog has finished closing. */
            this._afterClosed = new rxjs.Subject();
            // Pass the id along to the portal.
            _portalInstance._id = id;
            _overlayRef.detachments().subscribe(function () {
                _this._beforeClosed.next(_this._result);
                _this._beforeClosed.complete();
                _this._afterClosed.next(_this._result);
                _this._afterClosed.complete();
                _this.componentInstance = null;
                _this._overlayRef.dispose();
            });
        }
        /**
         * Close the dialog.
         * @param dialogResult Optional result to return to the dialog opener.
         */
        MdcDialogRef.prototype.close = function (dialogResult) {
            this._result = dialogResult;
            this._overlayRef.dispose();
        };
        /** Marks the dialog as opened. */
        MdcDialogRef.prototype.opened = function () {
            if (!this._afterOpened.closed) {
                this._afterOpened.next();
                this._afterOpened.complete();
            }
        };
        /** Gets an observable that is notified when the dialog is finished opening. */
        MdcDialogRef.prototype.afterOpened = function () {
            return this._afterOpened.asObservable();
        };
        /** Gets an observable that is notified when the dialog has started closing. */
        MdcDialogRef.prototype.beforeClosed = function () {
            return this._beforeClosed.asObservable();
        };
        /** Gets an observable that is notified when the dialog is finished closing. */
        MdcDialogRef.prototype.afterClosed = function () {
            return this._afterClosed.asObservable();
        };
        return MdcDialogRef;
    }());

    /*! *****************************************************************************
    Copyright (c) Microsoft Corporation. All rights reserved.
    Licensed under the Apache License, Version 2.0 (the "License"); you may not use
    this file except in compliance with the License. You may obtain a copy of the
    License at http://www.apache.org/licenses/LICENSE-2.0

    THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
    KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
    WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
    MERCHANTABLITY OR NON-INFRINGEMENT.

    See the Apache Version 2.0 License for specific language governing permissions
    and limitations under the License.
    ***************************************************************************** */
    /* global Reflect, Promise */

    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };

    function __extends(d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    }

    var __assign = function() {
        __assign = Object.assign || function __assign(t) {
            for (var s, i = 1, n = arguments.length; i < n; i++) {
                s = arguments[i];
                for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
            }
            return t;
        };
        return __assign.apply(this, arguments);
    };

    function __rest(s, e) {
        var t = {};
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
            t[p] = s[p];
        if (s != null && typeof Object.getOwnPropertySymbols === "function")
            for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
                if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                    t[p[i]] = s[p[i]];
            }
        return t;
    }

    function __decorate(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    }

    function __param(paramIndex, decorator) {
        return function (target, key) { decorator(target, key, paramIndex); }
    }

    function __metadata(metadataKey, metadataValue) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
    }

    function __awaiter(thisArg, _arguments, P, generator) {
        function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
        return new (P || (P = Promise))(function (resolve, reject) {
            function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
            function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
            function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
            step((generator = generator.apply(thisArg, _arguments || [])).next());
        });
    }

    function __generator(thisArg, body) {
        var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
        return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
        function verb(n) { return function (v) { return step([n, v]); }; }
        function step(op) {
            if (f) throw new TypeError("Generator is already executing.");
            while (_) try {
                if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
                if (y = 0, t) op = [op[0] & 2, t.value];
                switch (op[0]) {
                    case 0: case 1: t = op; break;
                    case 4: _.label++; return { value: op[1], done: false };
                    case 5: _.label++; y = op[1]; op = [0]; continue;
                    case 7: op = _.ops.pop(); _.trys.pop(); continue;
                    default:
                        if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                        if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                        if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                        if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                        if (t[2]) _.ops.pop();
                        _.trys.pop(); continue;
                }
                op = body.call(thisArg, _);
            } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
            if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
        }
    }

    function __exportStar(m, exports) {
        for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
    }

    function __values(o) {
        var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
        if (m) return m.call(o);
        if (o && typeof o.length === "number") return {
            next: function () {
                if (o && i >= o.length) o = void 0;
                return { value: o && o[i++], done: !o };
            }
        };
        throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
    }

    function __read(o, n) {
        var m = typeof Symbol === "function" && o[Symbol.iterator];
        if (!m) return o;
        var i = m.call(o), r, ar = [], e;
        try {
            while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
        }
        catch (error) { e = { error: error }; }
        finally {
            try {
                if (r && !r.done && (m = i["return"])) m.call(i);
            }
            finally { if (e) throw e.error; }
        }
        return ar;
    }

    function __spread() {
        for (var ar = [], i = 0; i < arguments.length; i++)
            ar = ar.concat(__read(arguments[i]));
        return ar;
    }

    function __spreadArrays() {
        for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
        for (var r = Array(s), k = 0, i = 0; i < il; i++)
            for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
                r[k] = a[j];
        return r;
    };

    function __await(v) {
        return this instanceof __await ? (this.v = v, this) : new __await(v);
    }

    function __asyncGenerator(thisArg, _arguments, generator) {
        if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
        var g = generator.apply(thisArg, _arguments || []), i, q = [];
        return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
        function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
        function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
        function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
        function fulfill(value) { resume("next", value); }
        function reject(value) { resume("throw", value); }
        function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
    }

    function __asyncDelegator(o) {
        var i, p;
        return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
        function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
    }

    function __asyncValues(o) {
        if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
        var m = o[Symbol.asyncIterator], i;
        return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
        function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
        function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
    }

    function __makeTemplateObject(cooked, raw) {
        if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
        return cooked;
    };

    function __importStar(mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
        result.default = mod;
        return result;
    }

    function __importDefault(mod) {
        return (mod && mod.__esModule) ? mod : { default: mod };
    }

    function __classPrivateFieldGet(receiver, privateMap) {
        if (!privateMap.has(receiver)) {
            throw new TypeError("attempted to get private field on non-instance");
        }
        return privateMap.get(receiver);
    }

    function __classPrivateFieldSet(receiver, privateMap, value) {
        if (!privateMap.has(receiver)) {
            throw new TypeError("attempted to set private field on non-instance");
        }
        privateMap.set(receiver, value);
        return value;
    }

    var MdcDialogPortal = /** @class */ (function (_super) {
        __extends(MdcDialogPortal, _super);
        function MdcDialogPortal(_elementRef, _focusTrapFactory, _document, _config) {
            var _this = _super.call(this) || this;
            _this._elementRef = _elementRef;
            _this._focusTrapFactory = _focusTrapFactory;
            _this._document = _document;
            _this._config = _config;
            /** Element that was focused before the dialog was opened. Save this to restore upon close. */
            _this._elementFocusedBeforeDialogWasOpened = null;
            /** A subject emitting after the dialog exits the view. */
            _this._afterExit = new rxjs.Subject();
            return _this;
        }
        /**
         * Attach a ComponentPortal as content to this dialog container.
         * @param portal Portal to be attached as the dialog content.
         */
        MdcDialogPortal.prototype.attachComponentPortal = function (portal) {
            this._savePreviouslyFocusedElement();
            return this._portalOutlet.attachComponentPortal(portal);
        };
        /**
         * Attach a TemplatePortal as content to this dialog container.
         * @param portal Portal to be attached as the dialog content.
         */
        MdcDialogPortal.prototype.attachTemplatePortal = function (portal) {
            this._savePreviouslyFocusedElement();
            return this._portalOutlet.attachTemplatePortal(portal);
        };
        /** Moves the focus inside the focus trap. */
        MdcDialogPortal.prototype.trapFocus = function () {
            var element = this._elementRef.nativeElement;
            if (!this._focusTrap) {
                this._focusTrap = this._focusTrapFactory.create(element);
            }
            // If we were to attempt to focus immediately, then the content of the dialog would not yet be
            // ready in instances where change detection has to run first. To deal with this, we simply
            // wait for the microtask queue to be empty.
            if (this._config.autoFocus) {
                this._focusTrap.focusInitialElementWhenReady();
            }
            else {
                var activeElement = this._document.activeElement;
                // Otherwise ensure that focus is on the dialog container. It's possible that a different
                // component tried to move focus. Note that we only want to do this
                // if the focus isn't inside the dialog already, because it's possible that the consumer
                // turned off `autoFocus` in order to move focus themselves.
                if (activeElement !== element && !element.contains(activeElement)) {
                    element.focus();
                }
            }
        };
        /** Restores focus to the element that was focused before the dialog opened. */
        MdcDialogPortal.prototype.restoreFocus = function () {
            var toFocus = this._elementFocusedBeforeDialogWasOpened;
            // We need the extra check, because IE can set the `activeElement` to null in some cases.
            if (this._config.restoreFocus && toFocus && typeof toFocus.focus === 'function') {
                toFocus.focus();
            }
            if (this._focusTrap) {
                this._focusTrap.destroy();
            }
        };
        /** Saves a reference to the element that was focused before the dialog was opened. */
        MdcDialogPortal.prototype._savePreviouslyFocusedElement = function () {
            var _this = this;
            if (this._document) {
                this._elementFocusedBeforeDialogWasOpened = this._document.activeElement;
                // Note that there is no focus method when rendering on the server.
                if (this._elementRef.nativeElement.focus) {
                    // Move focus onto the dialog immediately in order to prevent the user from accidentally
                    // opening multiple dialogs at the same time. Needs to be async, because the element
                    // may not be focusable immediately.
                    Promise.resolve().then(function () { return _this._elementRef.nativeElement.focus(); });
                }
            }
        };
        MdcDialogPortal.decorators = [
            { type: core.Component, args: [{
                        selector: 'mdc-dialog-portal',
                        host: {
                            '[attr.id]': '_id'
                        },
                        template: '<ng-template cdkPortalOutlet></ng-template>',
                        changeDetection: core.ChangeDetectionStrategy.OnPush,
                        encapsulation: core.ViewEncapsulation.None
                    }] }
        ];
        /** @nocollapse */
        MdcDialogPortal.ctorParameters = function () { return [
            { type: core.ElementRef },
            { type: a11y.FocusTrapFactory },
            { type: undefined, decorators: [{ type: core.Optional }, { type: core.Inject, args: [common.DOCUMENT,] }] },
            { type: MdcDialogConfig }
        ]; };
        MdcDialogPortal.propDecorators = {
            _portalOutlet: [{ type: core.ViewChild, args: [portal.CdkPortalOutlet, { static: true },] }]
        };
        return MdcDialogPortal;
    }(portal.BasePortalOutlet));

    var MdcDialogAction = /** @class */ (function () {
        function MdcDialogAction(elementRef) {
            this.elementRef = elementRef;
            this._action = '';
        }
        Object.defineProperty(MdcDialogAction.prototype, "action", {
            get: function () {
                return this._action;
            },
            set: function (action) {
                // If the directive is set without a name (updated programatically), then this setter will
                // trigger with an empty string and should not overwrite the programatically set value.
                if (!action) {
                    return;
                }
                this._action = action;
                this.elementRef.nativeElement.setAttribute('data-mdc-dialog-action', this._action);
            },
            enumerable: true,
            configurable: true
        });
        MdcDialogAction.decorators = [
            { type: core.Directive, args: [{ selector: '[mdcDialogAction]' },] }
        ];
        /** @nocollapse */
        MdcDialogAction.ctorParameters = function () { return [
            { type: core.ElementRef }
        ]; };
        MdcDialogAction.propDecorators = {
            action: [{ type: core.Input, args: ['mdcDialogAction',] }]
        };
        return MdcDialogAction;
    }());
    var MdcDialogScrim = /** @class */ (function () {
        function MdcDialogScrim(elementRef) {
            this.elementRef = elementRef;
        }
        MdcDialogScrim.decorators = [
            { type: core.Directive, args: [{
                        selector: 'mdc-dialog-scrim',
                        host: { 'class': 'mdc-dialog__scrim' }
                    },] }
        ];
        /** @nocollapse */
        MdcDialogScrim.ctorParameters = function () { return [
            { type: core.ElementRef }
        ]; };
        return MdcDialogScrim;
    }());
    var MdcDialogContainer = /** @class */ (function () {
        function MdcDialogContainer(elementRef) {
            this.elementRef = elementRef;
        }
        MdcDialogContainer.decorators = [
            { type: core.Directive, args: [{
                        selector: '[mdcDialogContainer], mdc-dialog-container',
                        host: { 'class': 'mdc-dialog__container' }
                    },] }
        ];
        /** @nocollapse */
        MdcDialogContainer.ctorParameters = function () { return [
            { type: core.ElementRef }
        ]; };
        return MdcDialogContainer;
    }());
    var MdcDialogSurface = /** @class */ (function () {
        function MdcDialogSurface(elementRef) {
            this.elementRef = elementRef;
        }
        MdcDialogSurface.decorators = [
            { type: core.Directive, args: [{
                        selector: '[mdcDialogSurface], mdc-dialog-surface',
                        host: { 'class': 'mdc-dialog__surface' }
                    },] }
        ];
        /** @nocollapse */
        MdcDialogSurface.ctorParameters = function () { return [
            { type: core.ElementRef }
        ]; };
        return MdcDialogSurface;
    }());
    var MdcDialogTitle = /** @class */ (function () {
        function MdcDialogTitle(elementRef) {
            this.elementRef = elementRef;
        }
        MdcDialogTitle.decorators = [
            { type: core.Directive, args: [{
                        selector: '[mdcDialogTitle], mdc-dialog-title',
                        host: { 'class': 'mdc-dialog__title' }
                    },] }
        ];
        /** @nocollapse */
        MdcDialogTitle.ctorParameters = function () { return [
            { type: core.ElementRef }
        ]; };
        return MdcDialogTitle;
    }());
    var MdcDialogContent = /** @class */ (function () {
        function MdcDialogContent(elementRef) {
            this.elementRef = elementRef;
        }
        MdcDialogContent.decorators = [
            { type: core.Directive, args: [{
                        selector: '[mdcDialogContent], mdc-dialog-content',
                        host: { 'class': 'mdc-dialog__content' }
                    },] }
        ];
        /** @nocollapse */
        MdcDialogContent.ctorParameters = function () { return [
            { type: core.ElementRef }
        ]; };
        return MdcDialogContent;
    }());
    var MdcDialogActions = /** @class */ (function () {
        function MdcDialogActions(elementRef) {
            this.elementRef = elementRef;
            this._stacked = false;
        }
        Object.defineProperty(MdcDialogActions.prototype, "stacked", {
            get: function () {
                return this._stacked;
            },
            set: function (value) {
                this._stacked = coercion.coerceBooleanProperty(value);
            },
            enumerable: true,
            configurable: true
        });
        MdcDialogActions.decorators = [
            { type: core.Component, args: [{
                        selector: 'mdc-dialog-actions, [mdcDialogActions]',
                        template: '<ng-content></ng-content>',
                        exportAs: 'mdcDialogActions',
                        host: {
                            'class': 'mdc-dialog__actions',
                            '[class.mdc-dialog--stacked]': 'stacked'
                        },
                        encapsulation: core.ViewEncapsulation.None,
                        changeDetection: core.ChangeDetectionStrategy.OnPush
                    }] }
        ];
        /** @nocollapse */
        MdcDialogActions.ctorParameters = function () { return [
            { type: core.ElementRef }
        ]; };
        MdcDialogActions.propDecorators = {
            stacked: [{ type: core.Input }]
        };
        return MdcDialogActions;
    }());
    var MdcDialogButton = /** @class */ (function (_super) {
        __extends(MdcDialogButton, _super);
        function MdcDialogButton() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this._default = false;
            return _this;
        }
        Object.defineProperty(MdcDialogButton.prototype, "default", {
            get: function () {
                return this._default;
            },
            set: function (value) {
                this._default = coercion.coerceBooleanProperty(value);
            },
            enumerable: true,
            configurable: true
        });
        MdcDialogButton.decorators = [
            { type: core.Component, args: [{
                        selector: '[mdcDialogButton]',
                        exportAs: 'mdcDialogButton',
                        host: {
                            'class': 'mdc-dialog__button',
                            '[class.mdc-button]': 'true',
                            '[class.mdc-dialog__button--default]': 'default'
                        },
                        template: "\n  <div class=\"mdc-button__ripple\"></div>\n  <ng-content></ng-content>",
                        providers: [ripple.MdcRipple],
                        encapsulation: core.ViewEncapsulation.None,
                        changeDetection: core.ChangeDetectionStrategy.OnPush
                    }] }
        ];
        MdcDialogButton.propDecorators = {
            default: [{ type: core.Input }]
        };
        return MdcDialogButton;
    }(button.MdcButton));

    var LAYOUT_EVENTS = ['resize', 'orientationchange'];
    var MdcDialogComponent = /** @class */ (function (_super) {
        __extends(MdcDialogComponent, _super);
        function MdcDialogComponent(_ngZone, _platform, elementRef, dialogRef) {
            var _this = _super.call(this, elementRef) || this;
            _this._ngZone = _ngZone;
            _this._platform = _platform;
            _this.elementRef = elementRef;
            _this.dialogRef = dialogRef;
            /** Emits whenever the component is destroyed. */
            _this._destroy = new rxjs.Subject();
            _this._scrollable = true;
            _this._layoutEventSubscription = null;
            _this.config = dialogRef._portalInstance._config;
            return _this;
        }
        Object.defineProperty(MdcDialogComponent.prototype, "layoutEvents", {
            /** Combined stream of all of the dialog layout events. */
            get: function () {
                return rxjs.merge.apply(void 0, __spread(LAYOUT_EVENTS.map(function (evt) { return rxjs.fromEvent(window, evt); })));
            },
            enumerable: true,
            configurable: true
        });
        MdcDialogComponent.prototype.getDefaultFoundation = function () {
            var _this = this;
            var adapter = {
                addClass: function (className) { return _this._getDialog().classList.add(className); },
                removeClass: function (className) { return _this._getDialog().classList.remove(className); },
                getInitialFocusEl: function () { return _this._platform.isBrowser
                    ? document.querySelector("[cdkFocusInitial]") : null; },
                hasClass: function (className) { return _this._getDialog().classList.contains(className); },
                addBodyClass: function (className) {
                    if (_this._platform.isBrowser) {
                        document.body.classList.add(className);
                    }
                },
                removeBodyClass: function (className) {
                    if (_this._platform.isBrowser) {
                        document.body.classList.remove(className);
                    }
                },
                eventTargetMatches: function (target, selector) { return dom.matches(target, selector); },
                trapFocus: function () { },
                releaseFocus: function () { },
                isContentScrollable: function () {
                    return !!_this._content && _this._scrollable && dialog.util.isScrollable(_this._content.elementRef.nativeElement);
                },
                areButtonsStacked: function () { return dialog.util.areTopsMisaligned(_this._buttons); },
                getActionFromEvent: function (event) {
                    var element = dom.closest(event.target, "[" + dialog.strings.ACTION_ATTRIBUTE + "]");
                    return element && element.getAttribute(dialog.strings.ACTION_ATTRIBUTE);
                },
                clickDefaultButton: function () {
                    var _a, _b;
                    var defaultBtn = _this._buttons.find(function (_) { return _.default; });
                    (_b = (_a = defaultBtn === null || defaultBtn === void 0 ? void 0 : defaultBtn.elementRef) === null || _a === void 0 ? void 0 : _a.nativeElement) === null || _b === void 0 ? void 0 : _b.click();
                },
                reverseButtons: function () {
                    _this._buttons.toArray().reverse();
                    _this._buttons.forEach(function (button) { return button.getHostElement().parentElement.appendChild(button.getHostElement()); });
                },
                notifyOpened: function () { return _this.dialogRef.opened(); },
                notifyOpening: function () { },
                notifyClosed: function (action) { return _this._closeDialogByRef(action); },
                notifyClosing: function () { }
            };
            return new dialog.MDCDialogFoundation(adapter);
        };
        MdcDialogComponent.prototype.ngAfterViewInit = function () {
            this._foundation = this.getDefaultFoundation();
            this._initialize();
            this._loadListeners();
            this._foundation.open();
        };
        MdcDialogComponent.prototype._initialize = function () {
            this._scrollable = !!this.config.scrollable;
            if (!this.config.clickOutsideToClose) {
                this._foundation.setScrimClickAction('');
            }
            if (!this.config.escapeToClose) {
                this._foundation.setEscapeKeyAction('');
            }
            if (!this.config.buttonsStacked) {
                this._foundation.setAutoStackButtons(false);
            }
        };
        MdcDialogComponent.prototype.ngOnDestroy = function () {
            var _a, _b;
            this._destroy.next();
            this._destroy.complete();
            (_a = this._layoutEventSubscription) === null || _a === void 0 ? void 0 : _a.unsubscribe();
            (_b = this._foundation) === null || _b === void 0 ? void 0 : _b.destroy();
        };
        /** Recalculates layout and automatically adds/removes modifier classes like --scrollable. */
        MdcDialogComponent.prototype.layout = function () {
            this._foundation.layout();
        };
        MdcDialogComponent.prototype._onKeydown = function (evt) {
            this._foundation.handleKeydown(evt);
        };
        MdcDialogComponent.prototype._onClick = function (evt) {
            this._foundation.handleClick(evt);
        };
        MdcDialogComponent.prototype._closeDialogByRef = function (action) {
            this.dialogRef.close(action);
        };
        MdcDialogComponent.prototype._loadListeners = function () {
            var _this = this;
            this._layoutEventSubscription = this.layoutEvents.pipe()
                .subscribe(function () { return _this.layout(); });
            if (this._platform.isBrowser) {
                this._ngZone.runOutsideAngular(function () {
                    return rxjs.fromEvent(document, 'keydown').pipe(operators.takeUntil(_this._destroy))
                        .subscribe(function (evt) { return _this._ngZone.run(function () { return _this._foundation.handleDocumentKeydown(evt); }); });
                });
            }
        };
        /** Retrieves the DOM element of the component host. */
        MdcDialogComponent.prototype._getDialog = function () {
            return this._elementRef.nativeElement;
        };
        MdcDialogComponent.decorators = [
            { type: core.Component, args: [{
                        selector: 'mdc-dialog',
                        exportAs: 'mdc-dialog',
                        host: {
                            '[attr.id]': 'config?.id',
                            'role': 'alertdialog',
                            'class': 'mdc-dialog',
                            '[attr.aria-modal]': 'true',
                            '[attr.aria-labelledby]': 'config?.ariaLabel',
                            '[attr.aria-label]': 'config?.ariaLabel',
                            '[attr.aria-describedby]': 'config?.ariaDescribedBy || null',
                            '(click)': '_onClick($event)',
                            '(keydown)': '_onKeydown($event)'
                        },
                        template: "\n  <mdc-dialog-scrim></mdc-dialog-scrim>\n  <ng-content></ng-content>",
                        encapsulation: core.ViewEncapsulation.None,
                        changeDetection: core.ChangeDetectionStrategy.OnPush
                    }] }
        ];
        /** @nocollapse */
        MdcDialogComponent.ctorParameters = function () { return [
            { type: core.NgZone },
            { type: platform.Platform },
            { type: core.ElementRef },
            { type: MdcDialogRef }
        ]; };
        MdcDialogComponent.propDecorators = {
            _surface: [{ type: core.ContentChild, args: [MdcDialogSurface, { static: false },] }],
            _content: [{ type: core.ContentChild, args: [MdcDialogContent, { static: false },] }],
            _buttons: [{ type: core.ContentChildren, args: [MdcDialogButton, { descendants: true },] }]
        };
        return MdcDialogComponent;
    }(base.MDCComponent));

    /** Injection token that can be used to access the data that was passed in to a dialog. */
    var MDC_DIALOG_DATA = new core.InjectionToken('MdcDialogData');
    /** Injection token that can be used to specify default dialog options. */
    var MDC_DIALOG_DEFAULT_OPTIONS = new core.InjectionToken('mdc-dialog-default-options');
    var MdcDialog = /** @class */ (function () {
        function MdcDialog(_overlay, _injector, _defaultOptions, _parentDialog) {
            var _this = this;
            this._overlay = _overlay;
            this._injector = _injector;
            this._defaultOptions = _defaultOptions;
            this._parentDialog = _parentDialog;
            this._openDialogsAtThisLevel = [];
            this._afterAllClosedAtThisLevel = new rxjs.Subject();
            this._afterOpenedAtThisLevel = new rxjs.Subject();
            this._ariaHiddenElements = new Map();
            /**
             * Stream that emits when all open dialog have finished closing.
             * Will emit on subscribe if there are no open dialogs to begin with.
             */
            this.afterAllClosed = rxjs.defer(function () { return _this.openDialogs.length ?
                _this._afterAllClosed :
                _this._afterAllClosed.pipe(operators.startWith(undefined)); });
        }
        Object.defineProperty(MdcDialog.prototype, "openDialogs", {
            /** Keeps track of the currently-open dialogs. */
            get: function () {
                return this._parentDialog ? this._parentDialog.openDialogs : this._openDialogsAtThisLevel;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MdcDialog.prototype, "afterOpened", {
            /** Stream that emits when a dialog has been opened. */
            get: function () {
                return this._parentDialog ? this._parentDialog.afterOpened : this._afterOpenedAtThisLevel;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MdcDialog.prototype, "_afterAllClosed", {
            get: function () {
                var parent = this._parentDialog;
                return parent ? parent._afterAllClosed : this._afterAllClosedAtThisLevel;
            },
            enumerable: true,
            configurable: true
        });
        /**
         * Opens a modal dialog containing the given template.
         * @param componentOrTemplateRef Type of the component to load into the dialog,
         *     or a TemplateRef to instantiate as the dialog content.
         * @param config Extra configuration options.
         * @returns Reference to the newly-opened dialog.
         */
        MdcDialog.prototype.open = function (componentOrTemplateRef, config) {
            var _this = this;
            config = _applyConfigDefaults(config, this._defaultOptions || new MdcDialogConfig());
            if (config.id && this.getDialogById(config.id)) {
                throw Error("Dialog with id \"" + config.id + "\" exists already. The dialog id must be unique.");
            }
            var overlayRef = this._createOverlay();
            var dialogContainer = this._attachDialogContainer(overlayRef, config);
            var dialogRef = this._attachDialogContent(componentOrTemplateRef, dialogContainer, overlayRef, config);
            this.openDialogs.push(dialogRef);
            dialogRef.afterClosed().subscribe(function () { return _this._removeOpenDialog(dialogRef, dialogContainer); });
            this.afterOpened.next(dialogRef);
            return dialogRef;
        };
        /** Closes all of the currently-open dialogs. */
        MdcDialog.prototype.closeAll = function () {
            this._closeDialogs(this.openDialogs);
        };
        /**
         * Finds an open dialog by its id.
         * @param id ID to use when looking up the dialog.
         */
        MdcDialog.prototype.getDialogById = function (id) {
            return this.openDialogs.find(function (dialog) { return dialog.id === id; });
        };
        MdcDialog.prototype.ngOnDestroy = function () {
            // Only close the dialogs at this level on destroy
            // since the parent service may still be active.
            this._closeDialogs(this._openDialogsAtThisLevel);
            this._afterAllClosedAtThisLevel.complete();
            this._afterOpenedAtThisLevel.complete();
        };
        /**
         * Creates the overlay into which the dialog will be loaded.
         * @returns A promise resolving to the OverlayRef for the created overlay.
         */
        MdcDialog.prototype._createOverlay = function () {
            return this._overlay.create();
        };
        /**
         * Attaches an MdcDialogPortal to a dialog's already-created overlay.
         * @param overlay Reference to the dialog's underlying overlay.
         * @param config The dialog configuration.
         * @returns A promise resolving to a ComponentRef for the attached container.
         */
        MdcDialog.prototype._attachDialogContainer = function (overlay, config) {
            var userInjector = config && config.viewContainerRef && config.viewContainerRef.injector;
            var injector = new portal.PortalInjector(userInjector || this._injector, new WeakMap([
                [MdcDialogConfig, config]
            ]));
            var containerPortal = new portal.ComponentPortal(MdcDialogPortal, config.viewContainerRef, injector, config.componentFactoryResolver);
            var containerRef = overlay.attach(containerPortal);
            return containerRef.instance;
        };
        /**
         * Attaches the user-provided component to the already-created MdcDialogPortal.
         * @param componentOrTemplateRef The type of component being loaded into the dialog,
         *     or a TemplateRef to instantiate as the content.
         * @param dialogContainer Reference to the wrapping MdcDialogPortal.
         * @param overlayRef Reference to the overlay in which the dialog resides.
         * @param config The dialog configuration.
         * @returns A promise resolving to the MdcDialogRef that should be returned to the user.
         */
        MdcDialog.prototype._attachDialogContent = function (componentOrTemplateRef, dialogContainer, overlayRef, config) {
            // Create a reference to the dialog we're creating in order to give the user a handle
            // to modify and close it.
            var dialogRef = new MdcDialogRef(overlayRef, dialogContainer, config.id);
            if (componentOrTemplateRef instanceof core.TemplateRef) {
                dialogContainer.attachTemplatePortal(new portal.TemplatePortal(componentOrTemplateRef, null, { $implicit: config.data, dialogRef: dialogRef }));
            }
            else {
                var injector = this._createInjector(config, dialogRef, dialogContainer);
                var contentRef = dialogContainer.attachComponentPortal(new portal.ComponentPortal(componentOrTemplateRef, config.viewContainerRef, injector));
                dialogRef.componentInstance = contentRef.instance;
            }
            return dialogRef;
        };
        /**
         * Creates a custom injector to be used inside the dialog. This allows a component loaded inside
         * of a dialog to close itself and, optionally, to return a value.
         * @param config Config object that is used to construct the dialog.
         * @param dialogRef Reference to the dialog.
         * @param container Dialog container element that wraps all of the contents.
         * @returns The custom injector that can be used inside the dialog.
         */
        MdcDialog.prototype._createInjector = function (config, dialogRef, portalContainer) {
            var userInjector = config && config.viewContainerRef && config.viewContainerRef.injector;
            portalContainer.trapFocus();
            // The MdcDialogPortal is injected in the portal as the MdcDialogPortal and the dialog's
            // content are created out of the same ViewContainerRef and as such, are siblings for injector
            // purposes. To allow the hierarchy that is expected, the MdcDialogPortal is explicitly
            // added to the injection tokens.
            var injectionTokens = new WeakMap([
                [MdcDialogPortal, portalContainer],
                [MDC_DIALOG_DATA, config.data],
                [MdcDialogRef, dialogRef]
            ]);
            return new portal.PortalInjector(userInjector || this._injector, injectionTokens);
        };
        /**
         * Removes a dialog from the array of open dialogs.
         * @param dialogRef Dialog to be removed.
         */
        MdcDialog.prototype._removeOpenDialog = function (dialogRef, dialogContainer) {
            var index = this.openDialogs.indexOf(dialogRef);
            if (index > -1) {
                dialogContainer.restoreFocus();
                this.openDialogs.splice(index, 1);
                // If all the dialogs were closed, remove/restore the `aria-hidden`
                // to a the siblings and emit to the `afterAllClosed` stream.
                if (!this.openDialogs.length) {
                    this._ariaHiddenElements.forEach(function (previousValue, element) {
                        if (previousValue) {
                            element.setAttribute('aria-hidden', previousValue);
                        }
                        else {
                            element.removeAttribute('aria-hidden');
                        }
                    });
                    this._ariaHiddenElements.clear();
                    this._afterAllClosed.next();
                }
            }
        };
        /** Closes all of the dialogs in an array. */
        MdcDialog.prototype._closeDialogs = function (dialogs) {
            var i = dialogs.length;
            while (i--) {
                // The `_openDialogs` property isn't updated after close until the rxjs subscription
                // runs on the next microtask, in addition to modifying the array as we're going
                // through it. We loop through all of them and call close without assuming that
                // they'll be removed from the list instantaneously.
                dialogs[i].close();
            }
        };
        MdcDialog.decorators = [
            { type: core.Injectable }
        ];
        /** @nocollapse */
        MdcDialog.ctorParameters = function () { return [
            { type: overlay.Overlay },
            { type: core.Injector },
            { type: MdcDialogConfig, decorators: [{ type: core.Optional }, { type: core.Inject, args: [MDC_DIALOG_DEFAULT_OPTIONS,] }] },
            { type: MdcDialog, decorators: [{ type: core.Optional }, { type: core.SkipSelf }] }
        ]; };
        return MdcDialog;
    }());
    /**
     * Applies default options to the dialog config.
     * @param config Config to be modified.
     * @param defaultOptions Default options provided.
     * @returns The new configuration object.
     */
    function _applyConfigDefaults(config, defaultOptions) {
        return __assign(__assign({}, defaultOptions), config);
    }

    var DIALOG_DECLARATIONS = [
        MdcDialogAction,
        MdcDialogActions,
        MdcDialogButton,
        MdcDialogComponent,
        MdcDialogContainer,
        MdcDialogPortal,
        MdcDialogContent,
        MdcDialogScrim,
        MdcDialogSurface,
        MdcDialogSurface,
        MdcDialogTitle
    ];
    var MdcDialogModule = /** @class */ (function () {
        function MdcDialogModule() {
        }
        MdcDialogModule.decorators = [
            { type: core.NgModule, args: [{
                        imports: [
                            overlay.OverlayModule,
                            portal.PortalModule,
                            button.MdcButtonModule,
                        ],
                        exports: DIALOG_DECLARATIONS,
                        declarations: DIALOG_DECLARATIONS,
                        providers: [MdcDialog],
                        entryComponents: [
                            MdcDialogPortal,
                            MdcDialogComponent
                        ]
                    },] }
        ];
        return MdcDialogModule;
    }());

    /**
     * Generated bundle index. Do not edit.
     */

    exports.MDC_DIALOG_DATA = MDC_DIALOG_DATA;
    exports.MDC_DIALOG_DEFAULT_OPTIONS = MDC_DIALOG_DEFAULT_OPTIONS;
    exports.MdcDialog = MdcDialog;
    exports.MdcDialogAction = MdcDialogAction;
    exports.MdcDialogActions = MdcDialogActions;
    exports.MdcDialogButton = MdcDialogButton;
    exports.MdcDialogComponent = MdcDialogComponent;
    exports.MdcDialogConfig = MdcDialogConfig;
    exports.MdcDialogContainer = MdcDialogContainer;
    exports.MdcDialogContent = MdcDialogContent;
    exports.MdcDialogModule = MdcDialogModule;
    exports.MdcDialogPortal = MdcDialogPortal;
    exports.MdcDialogRef = MdcDialogRef;
    exports.MdcDialogScrim = MdcDialogScrim;
    exports.MdcDialogSurface = MdcDialogSurface;
    exports.MdcDialogTitle = MdcDialogTitle;

    Object.defineProperty(exports, '__esModule', { value: true });

})));
//# sourceMappingURL=web-dialog.umd.js.map
